import type { CheckboxesConfig } from 'components/ui/page-header-with-filters';

const options: CheckboxesConfig['options'] = [
  { value: 'AG', label: 'AG' },
  { value: 'CD', label: 'CD' },
];
const checkboxesConfig: CheckboxesConfig = {
  options,
  defaultSelected: options.map((option) => option.value),
};

export const usePageHeaderConfig = () => {
  return { checkboxesConfig };
}